import EfScrollAni from '@/efscrollani';
import Crowdfunding from './detail';
import styles from './index.module.scss';
import { useProductStore } from './ProductProvider';
// import EfAniCircleBar from 'elem/ui/ef-ani-circle-bar';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styles.page}>
            {/* <div className="test">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda, expedita? Ullam quam excepturi perferendis repellendus fugit ad sit ducimus?
                Qui earum facere eius nihil, quos eveniet. Eligendi repellat sint sunt?
            </div> */}
            {/* <EfAniCircleBar /> */}
            <Crowdfunding />
        </div>
    );
}
